import React from 'react';
import { motion } from 'framer-motion';
import Button from '../common/Button';
import './CTA.css';

const CTA = ({ title, description, buttonText, buttonLink }) => {
  return (
    <section className="cta">
      <div className="container">
        <motion.div 
          className="cta-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>{title}</h2>
          <p>{description}</p>
          <Button 
            as="link" 
            to={buttonLink}
            primary
            large
          >
            {buttonText}
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;